import React from "react";
import { Editor } from "@tinymce/tinymce-react";
import { Box, FormHelperText } from "@mui/material";
 
import { useSidebarLayoutContext } from "contexts/SidebarLayoutContext";
 
import { BASE_CONSTANTS } from "constants/baseConstants";
 
// const TINY_CLOUD_API_KEY = "zqrsvtmeatld5mag3wlr175d0r1zdo1u8wcr0wvs3re77ow2";
 
const DEFAULT_CONFIG = {
  plugins: [
    "advlist autolink lists link image charmap print preview anchor",
    "searchreplace visualblocks code fullscreen",
    "insertdatetime media table paste code help wordcount",
    "link",
  ],
  toolbar:
    "undo redo | formatselect | " +
    "bold italic backcolor | alignleft aligncenter " +
    "alignright alignjustify | bullist numlist outdent indent | " +
    "link | " +
    "removeformat | help",
  content_style:
    "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
};
 
const RichTextEditor = ({
  label = "",
  required = false,
  initialValue,
  onChange = () => {},
  height = 200,
  menubar = false,
  error = false,
  helperText = "",
  disabled=false,
}) => {
  const editorRef = React.useRef(null);
 
  const { darkMode } = useSidebarLayoutContext();
 
  const initObject = React.useMemo(
    () => ({
      ...DEFAULT_CONFIG,
      height,
      menubar,
      ...(darkMode && {
        skin: "oxide-dark",
        content_css: "dark",
      }),
      selector: "textarea",
      draggable_modal: true,
      readonly:disabled,
    }),
    [darkMode, height, menubar, disabled]
  );
 
  return (
    <div className="grid grid-cols-1 gap-1">
      {!!label && (
        <Box paddingX={BASE_CONSTANTS.SPACING_SM}>
          <FormHelperText error={error}>
            {label}
            {required && "*"}
          </FormHelperText>
        </Box>
      )}
 
      <Editor
        // apiKey={TINY_CLOUD_API_KEY}
        onInit={(evt, editor) => (editorRef.current = editor)}
        tinymceScriptSrc={
          "https://cdnjs.cloudflare.com/ajax/libs/tinymce/7.1.1/tinymce.min.js"
        }
        placeholder="Placeholder"
        onEditorChange={onChange}
        initialValue={initialValue}
        init={initObject}
        disabled={disabled}
      />
 
      {!!helperText && (
        <Box paddingX={BASE_CONSTANTS.SPACING_SM}>
          <FormHelperText {...{ error }}>{helperText}</FormHelperText>
        </Box>
      )}
    </div>
  );
};
 
export default RichTextEditor;